import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {UserClientsContent} from "./UserClientsContent";

import {withRouterParams} from "../../utils/withRouterParams";

class UserClients extends Component {
    constructor(props) {
        super(props);
        this.afterSuccessfulAgencyClientSubmit = this.afterSuccessfulAgencyClientSubmit.bind(this);
    }

    redirectToAgencyRegisterPage() {
        this.props.history.push('/agency-register');
    }

    afterSuccessfulAgencyClientSubmit(newAgencyClientId, newAgencyClientName) {
        this.props.history.push(`/client/${newAgencyClientId}/`);
    }

    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <UserClientsContent />
            </div>
        )
    }
}

export default withRouterParams(UserClients);



